import { Trans } from '@lingui/react/macro';
import { Breakpoint } from '@mui/material';
import type { JSX } from 'react';

import { PrimaryButton } from '../../buttons';
import { Dialog, DialogActions, DialogContent } from '../../Dialog';

export function HelpDialog({
    title,
    body,
    width = 'xl',
    showDialog,
    onClose,
}: {
    title: string;
    body: JSX.Element;
    width?: Breakpoint;
    showDialog: boolean;
    onClose?: () => void;
}): JSX.Element {
    return (
        <>
            <Dialog maxWidth={width ?? false} onClose={onClose} title={title} open={showDialog}>
                <DialogContent>{body}</DialogContent>
                <DialogActions
                    sx={{
                        padding: '16px 24px',
                    }}
                >
                    <span style={{ flexGrow: 1 }} />
                    <PrimaryButton
                        onClick={() => {
                            onClose?.();
                        }}
                        size="small"
                        autoFocus
                        disableFocusRipple
                    >
                        <Trans>OK</Trans>
                    </PrimaryButton>
                </DialogActions>
            </Dialog>
        </>
    );
}
